module.exports = __webpack_public_path__ + "img/pr-16.378b3a66.png";